
<div id="app">
  <GlobalOverlay v-if="initialNavigationPending" class="boot-loader">
    <n-loading dark size="l" />
  </GlobalOverlay>
  <NavigationProgressBar />
  <router-view />
  <NConfirmModalProvider />
  <NSnackbarProvider />
  <UpgradeFeatureModalProvider />
  <VariableAssignmentProvider />
  <TableSlashSizePicker />
  <portal-target name="modal" multiple />
  <portal-target name="dropdown" multiple />
</div>
